import * as React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Selectors
// Selectors
import {
    makeSelectTimesheetValue
    // @ts-ignore
} from 'services/timesheets/selectors';

export interface OwnProps {
    timesheetId: number;
    children: React.ReactNode;
}

interface StateProps {
    isApproved?: boolean;
}

interface DispatchProps {}

type IProps = StateProps & DispatchProps & OwnProps;

export class TimesheetIsUnapprovedGate extends React.PureComponent<IProps> {
    render() {
        const { children, isApproved } = this.props;
        if (isApproved) return null;
        return children;
    }
}

const mapStateToProps = createStructuredSelector<any, any>({
    isApproved: makeSelectTimesheetValue('isApproved')
});

export default connect<StateProps, DispatchProps, OwnProps>(mapStateToProps)(
    TimesheetIsUnapprovedGate
);
